import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { Section } from "../../../components/Common/PageElement";
import { Container, Col } from "react-bootstrap";
import {
    AnnotoolSearchRow,
    AnnotoolIntermediateBox,
    AnnotoolIntermediateTitle,
    AnnotoolIntermediateText,
} from "../StyledAnnotoolSearch";
import CheckboxTree from "react-checkbox-tree";
import { Textbox } from "../../../components/Form";
import ButtonComponent from "../../../components/ButtonComponent";
import Fade from "react-reveal/Fade";
import { LoadContext } from "../../../context/LoadContext";
import {
    SERVER_URL,
    EVALUE_PLOT_API,
    PLOT_API, GENE_CLUSTER_HITS, ANNOTREE_BACKEND_URL, ANNOTREE_BACKEND_HITS, ANNOTREE_FRONTEND_URL,
} from "../../../services/Config";
import { useLocation } from "react-router-dom";
import "react-checkbox-tree/lib/react-checkbox-tree.css";


import {SERVER_PREFIX} from "../../../services/Config";
import {INTERMEDIATE_APPLICATION, STOP_LOADER} from "../../../services/Constant";
import IconButton from '@mui/material/IconButton';

import AnnoTreeImage from "../../../assets/AnnoTree/AnnoTree.png"
import AnnoTreeSpinner from "../../../assets/AnnoTree/loading-cargando.gif";
import {AnnotreeSearchRow} from "../../AnnotreeSearch/StyledAnnotreeSearch";
import TextField from "@material-ui/core/TextField";




const ImageButton = ({ altText, token, gtdbData, db }) => {
    const [isLoading, setIsLoading] = useState(false);

    const clickButton = () => {

        // console.log(gtdbData)
        if(gtdbData.length === 0){
            alert('Please select genomes you want to visualize on the left.')
            return
        }

        let gtdbIdList = gtdbData.map((curId,index)=>{
            let resultId = curId.split('/')
            return resultId[resultId.length-1]
        })
        // console.log(gtdbIdList)

        setIsLoading(true);

        const formData = new FormData();

        formData.append("token", token);
        formData.append("db", db);
        formData.append("gtdbData", gtdbIdList);


        axios
            .post(ANNOTREE_BACKEND_URL + ANNOTREE_BACKEND_HITS, formData)
            .then((response) => {
                setIsLoading(false);
                // console.log(response.data)
                // "?qtype=interpro&qstring=PF13000&eval=0.00001"
                // /#/?qtype=interpro&qstring=PF13000&eval=0.00001
                let database = db.includes('bacteria') ? 'bacteria':'archaea'
                let urlSuffix = `/#/?qtype=annotation&qstring=${database}_${token}&eval=0.00001`
                window.open(ANNOTREE_FRONTEND_URL + urlSuffix, '_blank');
            })
            .catch(() => {
                setIsLoading(false);
                alert("ERROR, AnnoTree distribution fetch error");
            });


    };

    return (
        <IconButton onClick={clickButton} style={{ position: 'relative' }}>
            <img src={AnnoTreeImage} alt={altText} style={{ maxWidth: '80%', maxHeight: '80%', opacity: isLoading ? 0.2 : 1 }} />
            {isLoading && <img src={AnnoTreeSpinner} alt="Loading..." style={{ maxWidth: '80%', maxHeight: '80%', position: 'absolute', top: '47.5%', left: '47.5%', transform: 'translate(-50%, -50%)' }} />}
        </IconButton>
    );
};


const AnnoTreeButton = ({ altText, token, gtdbData, db }) => {
    const [isLoading, setIsLoading] = useState(false);

    const clickButton = () => {

        // console.log(gtdbData)
        if(gtdbData.length === 0){
            alert('Please select genomes you want to visualize on the left.')
            return
        }

        // let gtdbIdList = gtdbData.map((curId,index)=>{
        //     let resultId = curId.split('/')
        //     return resultId[resultId.length-1]
        // })

        // -1 means gene_id, -2 means gtdb_id
        let gtdbIdList = gtdbData.map((curId,index)=>{
            let resultId = curId.split('/')
            return resultId[resultId.length-2]
        })


        setIsLoading(true);

        const formData = new FormData();

        formData.append("token", token);
        formData.append("db", db);
        formData.append("gtdbData", gtdbIdList);


        axios
            .post(ANNOTREE_BACKEND_URL + ANNOTREE_BACKEND_HITS, formData)
            .then((response) => {
                setIsLoading(false);
                console.log(response.data)
                // "?qtype=interpro&qstring=PF13000&eval=0.00001"
                // /#/?qtype=interpro&qstring=PF13000&eval=0.00001
                let database = db.includes('bacteria') ? 'bacteria':'archaea'
                let urlSuffix = `/#/?qtype=annotation&qstring=${database}_${token}&eval=0.00001`
                window.open(ANNOTREE_FRONTEND_URL + urlSuffix, '_blank');
            })
            .catch(() => {
                setIsLoading(false);
                alert("ERROR, AnnoTree distribution fetch error");
            });


    };

    return (
        // <IconButton onClick={clickButton} style={{ position: 'relative' }}>
        //     <img src={AnnoTreeImage} alt={altText} style={{ maxWidth: '80%', maxHeight: '80%', opacity: isLoading ? 0.2 : 1 }} />
        //     {isLoading && <img src={AnnoTreeSpinner} alt="Loading..." style={{ maxWidth: '80%', maxHeight: '80%', position: 'absolute', top: '47.5%', left: '47.5%', transform: 'translate(-50%, -50%)' }} />}
        // </IconButton>

        <ButtonComponent fill onClick={clickButton}>
            Check distribution in AnnoTree
        </ButtonComponent>
    );
};


const Intermediate = () => {
    const location = useLocation();
    const treeInfo = getNodeIdsWrapper(location.state.intermediateData)
    // console.log(treeInfo)

    const MAX_NUM_GENOMES = 1000;
    const { setLoad } = useContext(LoadContext);
    const [showTree, setShowTree] = useState(true);

    var numOfGenomes = 0;
    // this is actually the number of genomes
    const [intermediateEvalue, setIntermediateEvalue] = useState(-1);
    const [intermediateCoverage, setIntermediateCoverage] = useState(50);

    const [checked, setChecked] = useState([]);

    // tree checked will be the real tree hits that return to the backend
    const [treeChecked, setTreeChecked] = useState([]);

    const [expanded, setExpanded] = useState([]);

    const [intermediateData, setIntermediateData] = useState([]);
    const [token, setToken] = useState("");
    const [databaseValue, setDatabaseValue] = useState("");
    const [userEmail,setUserEmail] = useState("")

    const [coverage,setCoverage] = useState(10000)
    const [ids,setIds] = useState("")


    const [gtdbTreeChecked, setGtdbTreeChecked] = useState([]);
    const [contextRange, setContextRange] = useState('10000');

    const genomeLimit = 500;
    //
    // const handleShowTree = (val) => {
    //     setShowTree(val);
    // };

    // var urlToken = window.location.href
    //     .split("/").pop()

    function getNodeIdsWrapper(nodes){
        let treeInfo = getNodeIds(nodes)


        if(treeInfo['num'] === 1 && treeInfo['nodes'].length === 0){
            // console.log('hello')
            treeInfo['num'] = 0
        }
        return treeInfo
    }

    const isValidIntContextRange = (str) => {
        const intVal = parseInt(str, 10);
        return Number.isInteger(intVal) && intVal >= 0
    };


    function getNodeIds(nodes) {
        // if(!nodes){
        //     return
        // }

        let treeInfo = {'num':0,'nodes':[]}

        if(nodes){
            nodes.forEach(({ title,value, children }) => {
                // console.log(title)
                if(!children){
                    treeInfo['num'] += 1

                    treeInfo['nodes']  = [...treeInfo['nodes'], value]
                }
                else{
                    let tempTreeInfo = getNodeIds(children)
                    treeInfo['num'] += tempTreeInfo['num']
                    treeInfo['nodes']  = [...treeInfo['nodes'], value, ...tempTreeInfo['nodes']]
                }
                //
                // ids = [...ids, value, ...getNodeIds(children)];
            });
        }

        return treeInfo;
    }

    const levelOrder = ['domain','phylum','class','order','family','genus','species', 'genome', 'gene']
    const truncate_tree = (treeNode,limitLevel) =>{

        if(treeNode){
            // console.log('cut')
            // console.log(treeNode)
            let curLevel = treeNode['title']

            // if the taxonomy level is deeper than the limit
            // eg. if the current taxonomy level is 'species', and the limitLevel is genus, then
            // the function return and truncate the species level.

            if(levelOrder.indexOf(curLevel) === levelOrder.indexOf(limitLevel)){
                treeNode['children'] = []
                return treeNode
            }
            else{
                // let curChildren = treeNode['children']
                let curChildren = treeNode['children']
                // console.log(curChildren)
                if(curChildren){
                    curChildren.forEach((child,idx)=>{
                        // return truncate_tree(child,limitLevel)
                        curChildren[idx] = truncate_tree(child,limitLevel)
                    })
                }

            }

        }
        return treeNode
    }


    function findSubstrings(arr1, arr2) {
        let result = [];

        for (let str2 of arr2) {
            for (let str1 of arr1) {
                if (str2.includes(str1)) {
                    result.push(str2);
                    break; // Move to the next string in arr2 once a match is found
                }
            }
        }

        return result;
    }

    useEffect(() => {
        // console.log(location.state.limit_level)
        // console.log('hello')
        // console.log(location.state.intermediateData)


        let copyTree = JSON.parse(JSON.stringify(location.state.intermediateData))
        // console.log(typeof(location.state.intermediateData))
        let truncatedTree = [truncate_tree(copyTree[0],location.state.limit_level)]
        setUserEmail(location.state.userEmail)

        // setIntermediateData(location.state.intermediateData);
        setIntermediateData(truncatedTree);
        setToken(location.state.token);
        setDatabaseValue(location.state.databaseValue);
        setIds(location.state.ids)
        setCoverage(location.state.contextRange)


        setExpanded(treeInfo['nodes'])

        setIntermediateEvalue(numOfGenomes)
        // setExpanded(getNodeIds(location.state.intermediateDatas))
    }, [location]);


    const updateChecked = (treeChecked) =>{
        setChecked(treeChecked)
        let checkedDetails = findSubstrings(treeChecked, treeInfo['nodes'])
        let checkedHits =
            checkedDetails.
            map((item,i)=>{
                let checkedSplit = item.split('/')

                // hard coded, length is 10, reason:
                // 1* (acc/bac) + 7*taxonomy(domain,phylum....) + 1* genome_id + 1*gene_id = 10
                if(checkedSplit.length === 10){
                    return item
                }

                // // if only search for gtdb, then length is 9
                // if(checkedSplit.length === 9){
                //     return item
                // }
                return null
            }).filter((item)=>{

                return !!item;

            })

        // console.log(checkedHits)
        setTreeChecked(checkedHits)
        // setGtdbTreeChecked(gtdbHits)

    }


    const submit = () => {

        if((!showTree) && (intermediateEvalue > MAX_NUM_GENOMES)){
            alert("Max number of genomes is 500, please enter again")
            return
        }
        // if(showTree && checked.length > MAX_NUM_GENOMES){
        //     alert(`Please select ${genomeLimit} or fewer genomes to display`)
        //     return
        // }
        // if(showTree && checked.length === 0){
        //     alert("Please select genomes to display.")
        //     return
        // }

        if(showTree && treeChecked.length > MAX_NUM_GENOMES){
            alert(`Please select ${MAX_NUM_GENOMES} or fewer genomes to display`)
            return
        }
        if(showTree && treeChecked.length === 0){
            alert("Please select genomes to display.")
            return
        }




        if (contextRange === "" || !isValidIntContextRange(contextRange)) {
            alert('Please enter the correct context range value as an integer.')
            return
        }

        let intContextRange = parseInt(contextRange)
        if(intContextRange < 5000 || intContextRange > 50000){
            alert('Context range con only between 5000 and 20000')
            return
        }




        setLoad({'value':INTERMEDIATE_APPLICATION,'token':''});
        // console.log(treeChecked)
        // return
        const formData = new FormData();

        formData.append("token", token);
        formData.append("db", databaseValue);
        formData.append("ids", ids);
        // formData.append("sequence_text", dataText);
        // formData.append("evalue", evalue);
        formData.append("range", coverage);
        formData.append("token", token);
        formData.append("data",treeChecked)

        formData.append("contextRange",contextRange)

        axios
            .post(SERVER_URL + GENE_CLUSTER_HITS, formData)
            .then(() => {
                window.location.href = `${SERVER_PREFIX}/app/#/?id=` + token;
            })
            .catch(() => {
                setLoad({'value':STOP_LOADER,'token':''});
                // alert("ERROR,no genome selected by tree");
                alert("Sorry, no genomes contain your combination within the target range. Please consider increase context" +
                    "range.");
            });
        // Evalue

    };

    return (
        <Section height="full">
            <Container>
                <Fade top duration={1000} delay={600} distance="15px">
                    <AnnotoolSearchRow>
                        <Col>
                            <AnnotoolIntermediateBox
                                disabled={!showTree}
                                // onClick={() => {
                                //     handleShowTree(true);
                                // }}
                            >
                                <AnnotoolIntermediateTitle>
                                    Choose by Taxonomy
                                </AnnotoolIntermediateTitle>
                                {intermediateData.length === 0 ? (
                                    <AnnotoolIntermediateText>
                                        There are no significant matches
                                    </AnnotoolIntermediateText>
                                ) : (
                                    <>
                                        <AnnotoolIntermediateText>
                                            {/*Total selected: {checked.length-1 < 0? 0:checked.length-1}{" "}*/}

                                            {/*Total selected: {checked.length}{" "}*/}
                                            Total selected: {treeChecked.length}{" "}
                                            {/*matches (genomes)*/}
                                            matches (genes)
                                        </AnnotoolIntermediateText>
                                        <CheckboxTree
                                            disabled={!showTree}
                                            checked={checked}
                                            expanded={expanded}
                                            nodes={intermediateData}
                                            // onCheck={(val) => setChecked(val)}
                                            onCheck={(val) => updateChecked(val)}
                                            onExpand={(val) => setExpanded(val)}
                                            iconsClass="fa5"
                                            showNodeIcon={false}
                                        />
                                    </>
                                )}
                            </AnnotoolIntermediateBox>
                        </Col>
                        {/*<Col>*/}
                        {/*    <AnnotoolIntermediateBox*/}
                        {/*        disabled={showTree}*/}
                        {/*        // onClick={() => {*/}
                        {/*        //     handleShowTree(false);*/}
                        {/*        // }}*/}
                        {/*    >*/}
                        {/*        <AnnotoolIntermediateTitle>*/}
                        {/*            Check distribution in AnnoTree*/}
                        {/*        </AnnotoolIntermediateTitle>*/}
                        {/*        <div>*/}
                        {/*            <ImageButton altText={'AnnoTreeImg'}*/}
                        {/*                         gtdbData={treeChecked}*/}
                        {/*                         token={token}*/}
                        {/*                         db={databaseValue}*/}
                        {/*            />*/}
                        {/*        </div>*/}


                        {/*    </AnnotoolIntermediateBox>*/}
                        {/*</Col>*/}
                    </AnnotoolSearchRow>
                    <AnnotreeSearchRow>
                        <Col>

                            {/*there is a latency when user enter the value, this because the tree data is large for the frontend*/}
                            {/*<TextField*/}
                            {/*    label="Please enter the context range around the center gene, which should be between 5,000 and 20,000 bases."*/}
                            {/*    variant="outlined"*/}
                            {/*    fullWidth*/}
                            {/*    // value={contextRange}*/}
                            {/*    value={contextRange}*/}
                            {/*    onChange={(e)=>{*/}
                            {/*        setContextRange(e.target.value)}}*/}

                            {/*/>*/}
                            <Textbox
                                defaultvalue={contextRange}
                                formlabel="Context range"
                                // formlabel={"Minimum query coverage of the alignment"}
                                placeholder="Enter your context range for visualization (between 5k and 30k bases)"
                                onChange={(e) =>
                                    setContextRange(e.target.value)
                                }
                                // showDetail={true}
                            />
                        </Col>
                    </AnnotreeSearchRow>
                    <AnnotoolSearchRow>
                        <Col>

                            <AnnoTreeButton altText={'AnnoTreeImg'}
                                            gtdbData={treeChecked}
                                            token={token}
                                            db={databaseValue}
                            />

                        </Col>

                        {/*<Col md={{ span: 6, offset: 3 }}>*/}
                        <Col >
                            <ButtonComponent fill onClick={submit}>
                                Finish
                            </ButtonComponent>
                        </Col>
                    </AnnotoolSearchRow>
                </Fade>
            </Container>
        </Section>
    );
};

export default Intermediate;